// Replaces window.alert() for simple informational/validation messages — alert() is
// unreliable in iOS "Add to Home Screen" standalone mode, same class of bug as
// confirm()/prompt() (see PORT_STATUS.md / known-bugs list). A non-blocking toast that
// auto-dismisses is a better fit here anyway since these were always just "heads up,
// fix this field" messages, never something the flow actually needed to pause for.
let toastTimer = null;

function ensureToastEl() {
  let el = document.getElementById('appToast');
  if (!el) {
    el = document.createElement('div');
    el.id = 'appToast';
    el.style.cssText = [
      'position:fixed', 'left:50%', 'top:calc(16px + env(safe-area-inset-top,0))',
      'transform:translateX(-50%)', 'background:var(--text)', 'color:var(--bg)',
      'font-weight:600', 'font-size:13px', 'padding:10px 18px', 'border-radius:999px',
      'box-shadow:var(--sh-md)', 'z-index:500', 'max-width:88vw', 'text-align:center',
      'pointer-events:none', 'opacity:0', 'transition:opacity .2s ease'
    ].join(';');
    document.body.appendChild(el);
  }
  return el;
}

export function showToast(text) {
  const el = ensureToastEl();
  el.textContent = text;
  el.style.opacity = '1';
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => { el.style.opacity = '0'; }, 2400);
}
